import React, { Component } from "react";
import PropTypes from 'prop-types';
import { PrimaryButton } from '../../';
import isMobile from 'is-mobile';

import FiltersModal from './FiltersModals';
import './Filters.scss';

class Filters extends Component {
  static propTypes = {
    filters: PropTypes.array,
    onSave: PropTypes.func,
    currentFilter: PropTypes.num,
    setCurrentFilter: PropTypes.func,
    handleFilterItemsChange: PropTypes.func,
    mode: PropTypes.string
  }

  static defaultProps = {
    filters: [],
    uiFilters: [],
    onSave: () => {},
    currentFilter: null,
    setCurrentFilter: () => {},
  }

  state = {
    shouldRenderModal: false,
    shouldRenderFilterBar: false,
    isFilterModalBubbleRight: false,
    currentFilterSelectedItems: [],
  }

  componentDidMount() {
    this.setShouldRenderFilterBar();
    this.setVisibleFilters();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.slide !== this.props.slide) {
      this.setState({
        shouldRenderModal: false
      })
    }

    if ((prevProps.filters !== this.props.filters && this.props.uiFilters) || prevProps.slide !== this.props.slide) {
      this.setShouldRenderFilterBar();
      this.setVisibleFilters();
    }
  }

  shouldComponentUpdate() {
    return true;
  }

  setShouldRenderFilterBar = () => {
    const { filters, uiFilters } = this.props;

    if (!filters || filters && !filters.length) {
      return;
    }

    if (!uiFilters || uiFilters && !uiFilters.length) {
      return;
    }

    const visibleFilters = filters.filter((filter, index) => uiFilters.includes(index));
    const isFiltersItemsAreEmpty = visibleFilters.every(({ items }) => items && items.length === 0)

    this.setState({
      shouldRenderFilterBar: !isFiltersItemsAreEmpty
    })
  }

  setVisibleFilters = () => {
    const { filters, uiFilters } = this.props;

    if (!filters || filters && !filters.length) {
      return;
    }

    if (!uiFilters || uiFilters && !uiFilters.length) {
      return;
    }

    const visibleFilters = filters.filter((filter, index) => uiFilters.includes(index)) || [];

    this.setState({
      visibleFilters
    })
  }

  setCurrentFilter = index => {
    const { filters, currentFilter, setCurrentFilter } = this.props;
    const nextFilter = filters[index]
    ;
    if (currentFilter === index || index === null) {
      setCurrentFilter(null);

      this.setState({
        shouldRenderModal: false
      })
      return;
    }

    const originalSelectedItems = nextFilter && nextFilter.selectedItems || [];

    this.setState({
      currentFilterSelectedItems: originalSelectedItems
    })

    setCurrentFilter(index);

    this.openModal(index);
  }

  openModal(currentFilter) {
    const { filters, mode }  = this.props;
    const name = filters[currentFilter] && filters[currentFilter].name;
    const button = document.querySelector(`#filter-button-${name}`);
    const desktopFilterModal = document.querySelector(`#desktop-filter-modal`);
    const filterBar = document.querySelector('.filter-bar');
    const BUTTON_SIZE = 45 + 30;

    this.setState({
      shouldRenderModal: true
    });

    // Hack Land
    if (!isMobile()) {
      desktopFilterModal.style.visibility = 'hidden';

      setTimeout(() => {
        if (mode === 'table') {
          const modalBottom = (window.innerHeight - filterBar.getBoundingClientRect().bottom) + BUTTON_SIZE;
          let modalLeft = ((button.offsetLeft) + (button.clientWidth / 2)) - desktopFilterModal.clientWidth + (button.clientWidth / 2.8);

          this.setState({
            modalLeft,
            modalBottom,
            isFilterModalBubbleRight: true
          })
          desktopFilterModal.style.visibility = 'visible';
          return;
        }

        this.setState({
            modalLeft: (button.offsetLeft) + (button.clientWidth / 2) - 20
          });

          desktopFilterModal.style.visibility = 'visible';
      }, 0);
    }
  }

  handleClose = () => {
    const { setCurrentFilter } = this.props;

    this.setState({
      shouldRenderModal: false,
    }, () => {
      setCurrentFilter(null);
    })
  }

  handleSelectItem = (item, index) =>{
    const { filters, currentFilter } = this.props;
    const { currentFilterSelectedItems } = this.state;

    if (filters[currentFilter]) {
      const newSelectedItems = (
        currentFilterSelectedItems.includes(item) ?
        currentFilterSelectedItems.filter(selected => selected !== item) :
        [...currentFilterSelectedItems, item]
      );

      this.setState({
        currentFilterSelectedItems: newSelectedItems
      })
    }
  }

  handleSave = () => {
    const { handleFilterItemsChange, setCurrentFilter } = this.props;

    handleFilterItemsChange(this.state.currentFilterSelectedItems);
    setCurrentFilter(null);

    this.setState({
      shouldRenderModal: false,
      currentFilterSelectedItems: []
    })
  }

  handleClear = () => {
    const { handleFilterItemsChange, filters, currentFilter } = this.props;

    this.setState({
      currentFilterSelectedItems: []
    });

    handleFilterItemsChange([]);
    this.setCurrentFilter(null);
  }

  renderFilterBarItem = ({ name, title, items, itemsPrefix, selectedItems }, onFilterClick, index) => {
    const { isSmall } = this.props;

    if (!items || (items && !items.length)) {
      return;
    }

    return (
      <div>
        <PrimaryButton
          key={name}
          id={`filter-button-${name}`}
          onClick={() => onFilterClick(index)}
          className={`filters__bar__filter ${isSmall ? 'filters__bar__filter--small' : ''}`}
          background="#444"
          color="#fff"
          >
          {title}
          <Indicator num={(selectedItems && selectedItems.length) || 0} />
        </PrimaryButton>
      </div>
    )
  }

  renderFiltersModal = () => {
    const {
       currentFilterSelectedItems,
       shouldRenderModal,
       modalLeft,
       modalBottom,
       isFilterModalBubbleRight
      } = this.state;
    const { filters, currentFilter, isSmall } = this.props;
    const current = filters[currentFilter];
    const textKey = current && current.itemsTextKey || 'name';

    const { selectedItems, items, title, itemsPrefix } = current || { selectedItems: [], items: [], title: '', itemsPrefix: '' };
    const getTagClassName = item =>
      `
        filters__modal__tags__tag
        ${currentFilterSelectedItems.includes(item) ? 'filters__modal__tags__tag--selected' : ''}
      `;

    const getItemText = item => {
      if (typeof item === 'string' || typeof item === 'number') {
        return current.itemsPrefix ? `${itemsPrefix} ${item}` : item;
      }

      return current.itemsPrefix ? `${itemsPrefix} ${item[textKey]}` : item[textKey];
    }

    return (
      <FiltersModal
        isVisible={shouldRenderModal}
        onSave={this.handleSave}
        handleClose={this.handleClose}
        handleClear={this.handleClear}
        modalLeft={modalLeft}
        modalBottom={modalBottom}
        isFilterModalBubbleRight={isFilterModalBubbleRight}
      >
        <span className="filters__modal__title">{title}</span>
        <div className={`filters__modal__tags ${isSmall ? 'filters__modal__tags--small' : ''}`}>
          {items && items.map((item, itemIndex) => (
            <PrimaryButton
              key={getItemText(item)}
              className={getTagClassName(item)}
              onClick={() => this.handleSelectItem(item, itemIndex)}
              background="#313131"
              color='#FFF'
            >
              <span className="filters__modal__tags__tag__text">
                {getItemText(item)}
              </span>
            </PrimaryButton>
          ))}
        </div>
      </FiltersModal>
    )
  }

  render() {
    const { isSmall, ...props } = this.props;
    const { shouldRenderFilterBar, visibleFilters } = this.state;

    return shouldRenderFilterBar ? (
      <div { ...props }>
        <FilterBar onFilterClick={this.setCurrentFilter}>
          {this.renderFiltersModal()}
          <span className={`filters__bar__title ${isSmall ? 'filters__bar__title--small' : ''}`}>Filter By: </span>
          {
            visibleFilters && visibleFilters.map(
              (filter, index) => this.renderFilterBarItem(filter, this.setCurrentFilter, index)
            )
          }
        </FilterBar>
      </div>
    ) : null
  }
}

const FilterBar = ({ children }) => {
  return (
    <div className="filter-bar">
      {children}
    </div>
  )
}

FilterBar.propTypes = {
  setCurrentFilter: PropTypes.func
}

FilterBar.defaultProps ={
  setCurrentFilter: () => {}
}

const Indicator = ({ num }) => num ? (
  <span className="indicator">
    ({num})
  </span>
) : null

export default Filters;
